// DB-driven "Kontextmenü" configuration: which global-toolbar functions (plus
// separators) appear in the right-click plan menu, in which order, and which
// system-specific (product toolbar) functions are appended below a thick
// separator for the currently active system. Structure lives in the database
// (context_menu_global / context_menu_system, admin-managed via
// context_menu_admin_modal.js) — this module only loads and caches it.
//
// Mirrors global_menu_renderer.js's loadAndApplyGlobalMenuConfig fallback
// convention: on any failure (network error, unmigrated DB, fresh install)
// falls back to a hard-coded default so the context menu is never left
// blank. Must be kept in sync with the context_menu_global seed in
// backend/schema.sql / persistenceSchemaSql().
import { getActiveLanguage } from '../i18n/i18n_service.js?v=20260722a';
import { apiJson } from '../utils/api_utils.js?v=20260730a';

const CONTEXT_MENU_DEFAULT_GLOBAL_ENTRIES = [
  { entry_type: 'button', action_code: 'undo', label: 'Rückgängig', icon_key: 'undo' },
  { entry_type: 'button', action_code: 'redo', label: 'Vorwärts', icon_key: 'redo' },
  { entry_type: 'separator' },
  { entry_type: 'button', action_code: 'context-copy', label: 'Kopieren', icon_key: null },
  { entry_type: 'button', action_code: 'context-paste', label: 'Einfügen', icon_key: null },
  { entry_type: 'separator' },
  { entry_type: 'button', action_code: 'dimension-tool', label: 'Bemassung setzen', icon_key: 'dimension' },
  { entry_type: 'button', action_code: 'text-annotation-tool', label: 'A', icon_key: 'text-annotation' }
];

let globalEntries = CONTEXT_MENU_DEFAULT_GLOBAL_ENTRIES;
let systemEntries = [];

async function loadContextMenuConfig() {
  try {
    const [globalPayload, systemPayload] = await Promise.all([
      apiJson(`/api/context-menu?lang=${encodeURIComponent(getActiveLanguage())}`),
      apiJson('/api/context-menu/system')
    ]);
    globalEntries = Array.isArray(globalPayload.entries) && globalPayload.entries.length
      ? globalPayload.entries
      : CONTEXT_MENU_DEFAULT_GLOBAL_ENTRIES;
    systemEntries = Array.isArray(systemPayload.entries) ? systemPayload.entries : [];
  } catch (error) {
    console.warn('KS Studio: Kontextmenü-Konfiguration konnte nicht geladen werden, verwende Standard-Layout.', error);
    globalEntries = CONTEXT_MENU_DEFAULT_GLOBAL_ENTRIES;
    systemEntries = [];
  }
}

function contextMenuGlobalEntries() {
  return globalEntries;
}

function contextMenuSystemEntriesForSystem(systemCode) {
  if (!systemCode) return [];
  return systemEntries
    .filter(entry => entry.system_code === systemCode)
    .sort((a, b) => (a.sort_order ?? 999999) - (b.sort_order ?? 999999));
}

export {
  loadContextMenuConfig,
  contextMenuGlobalEntries,
  contextMenuSystemEntriesForSystem
};
